'use client';

import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import classNames from 'classnames';
import styles from './styles.module.scss';

const HeaderLinksResponsiveContainer = props => {
  const [showDropDown, setShowDropDown] = useState(false);
  return (
    <>
      <div
        onClick={() => setShowDropDown(false)}
        className={classNames(styles.headerLinksResponsiveContainer, showDropDown && styles.open)}
      >
        {props.children}
      </div>
      <div className={styles.burger} onClick={() => setShowDropDown(!showDropDown)}>
        <GiHamburgerMenu size={32} />
      </div>
    </>
  );
};

export default HeaderLinksResponsiveContainer;
